import { API_BASE_URL } from './config.js';
import fetchWrapper from '../components/utility/fetchWrapper.js';

const BASE = `${API_BASE_URL}/api/v1/connectors`;

export const connectorsService = {
  getTypes: async () => {
    const res = await fetchWrapper(`${BASE}/types`);
    if (!res.ok) throw new Error('Failed to load connector types');
    return res.json();
  },

  listInstances: async (params = {}, clientId = 'default') => {
    const qs = new URLSearchParams({ ...params, client_id: clientId }).toString();
    const res = await fetchWrapper(`${BASE}/instances?${qs}`);
    if (!res.ok) throw new Error('Failed to list connectors');
    return res.json();
  },

  createInstance: async (payload, clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/instances?client_id=${clientId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.detail || 'Failed to create connector');
    }
    return res.json();
  },

  updateInstance: async (connectorId, payload, clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/instances/${connectorId}?client_id=${clientId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error('Failed to update connector');
    return res.json();
  },

  deleteInstance: async (connectorId, clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/instances/${connectorId}?client_id=${clientId}`, {
      method: 'DELETE',
    });
    if (!res.ok) throw new Error('Failed to delete connector');
    return res.json();
  },

  testInstance: async (connectorId, clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/instances/${connectorId}/test?client_id=${clientId}`, {
      method: 'POST',
    });
    if (!res.ok) throw new Error('Failed to test connector');
    return res.json();
  },

  listJiraProjects: async (connectorId, clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/instances/${connectorId}/jira/projects?client_id=${clientId}`);
    if (!res.ok) throw new Error('Failed to load Jira projects');
    return res.json();
  },

  importEnvMcp: async (clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/import-env-mcp?client_id=${clientId}`, {
      method: 'POST',
    });
    if (!res.ok) throw new Error('Failed to import MCP connectors');
    return res.json();
  },

  listRepoMappings: async (clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/repo-mappings?client_id=${clientId}`);
    if (!res.ok) throw new Error('Failed to load repo mappings');
    return res.json();
  },

  createRepoMapping: async (payload, clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/repo-mappings?client_id=${clientId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error('Failed to create repo mapping');
    return res.json();
  },

  deleteRepoMapping: async (ruleId, clientId = 'default') => {
    const res = await fetchWrapper(`${BASE}/repo-mappings/${ruleId}?client_id=${clientId}`, {
      method: 'DELETE',
    });
    if (!res.ok) throw new Error('Failed to delete repo mapping');
    return res.json();
  },
};
